(function () {
    'use strict';

    angular.module("imApp").factory("docCategoryService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3723,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3724,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
